import httpGet from "./httpget";
import httpPost from './httppost';
const domain = "https://docsapi.foxitcloud.cn";
//获取文件列表数据
export const findDocFile = (config = {}) =>
  httpGet({
    url: `${domain}/docFile/findDocFile`,
    params:config.params,
    config
  });
//获取目录列表数据
export const findDocFolder = (config = {}) =>
  httpGet({
    url: `${domain}/docFolder/findDocFolder`,
    params:config.params,
    config
  });
//获取根目录id
export const getRootFolder = (config = {}) =>
  httpGet({
    url: `${domain}/docFolder/getRootFolder`,
    config
  });
//获取token
export const getToken = (params = {}, config = {}) =>
  httpGet({
    // url: `${domain}/user/getToken?fid=${window.readerCookies.fid||params.fid}`,
    url: `${domain}/user/getToken`,
    params,
    config
  });
//创建文件夹
export const addDocFolder = (config = {}) =>
  httpPost({
    url: `${domain}/docFolder/addDocFolder`,
    params: config.params,
    config
  });
//上传文件
export const upload = (config = {}) =>
  httpPost({
    url: `${domain}/docFile/upload`,
    params: config.params,
    config
  });
//获取用户信息保存用户的云文档容量
export const getUserInfo = (config = {}) =>
  httpGet({
    url: `${domain}/user/getUserInfo`,
    config
  });

// 分享功能相关接口
// 创建分享
export const createShare = (config = {}) =>
  httpPost({
    url: `${domain}/docShare/createShare`,
    params: config.params,
    config
  });

// 修改分享信息
export const updateShare = (config = {}) =>
  httpPost({
    url: `${domain}/docShare/updateShare`,
    params: config.params,
    config
  });
// 获取文件分享信息
export const getDocShare = (config = {}) =>
  httpGet({
    url: `${domain}/user/getDocShare`,
    params: config.params,
    config
  });
// 取消分享
export const cancelShare = (config = {}) =>
  httpPost({
    url: `${domain}/docShare/cancelShare`,
    params: config.params,
    config
  })
// 登录后获取token
export const getExchangeToken = (config = {}) =>
  httpGet({
    url: `${domain}/user/getExchangeToken`,
    params: config.params,
    config
  });
// 下载链接
  export const downloadURL = (config = {}) =>
  httpGet({
    url: `${domain}/docFile/downloadURL`,
    params: config.params,
    config
  });